var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNormal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFEA74"
    },
    d: "M148.088,371.324c0-21.1-17.105-38.205-38.205-38.205c-9.036,0-17.335,3.144-23.876,8.389 c-5.439-5.194-12.802-8.389-20.917-8.389c-16.734,0-30.301,13.566-30.301,30.301c0,4.031,0.794,7.876,2.224,11.395 c-13.6,4.998-23.302,18.064-23.302,33.397c0,19.645,15.925,35.57,35.57,35.57c7.732,0,37.156,7.905,48.744,7.905 c18.917,0,34.253-15.336,34.253-34.254C132.28,412.692,148.088,385.221,148.088,371.324z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62AF62"
    },
    d: "M124.641,335.721H95.537c-4.465,0-8.084-3.62-8.084-8.084c0-4.465,3.62-8.084,8.084-8.084h21.019 v-21.019c0-4.465,3.62-8.084,8.084-8.084c4.465,0,8.084,3.62,8.084,8.084v29.104C132.724,332.101,129.105,335.721,124.641,335.721z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#62AF62"
    },
    d: "M103.716,314.795H74.612c-4.465,0-8.084-3.62-8.084-8.084c0-4.465,3.62-8.084,8.084-8.084h21.019 v-21.018c0-4.465,3.62-8.084,8.084-8.084s8.084,3.62,8.084,8.084v29.104C111.8,311.176,108.18,314.795,103.716,314.795z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#519351"
    },
    d: "M144.766,355.848c-2.069,0-4.138-0.79-5.717-2.368l-65.096-65.096c-3.157-3.157-3.157-8.276,0-11.432 c3.157-3.157,8.276-3.157,11.432,0l65.096,65.096c3.157,3.157,3.157,8.276,0,11.432 C148.904,355.058,146.835,355.848,144.766,355.848z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8CF52"
    },
    d: "M101.32,384.981c-4.465,0-8.084-3.62-8.084-8.084c0-2.875-2.338-5.214-5.214-5.214 c-2.875,0-5.214,2.339-5.214,5.214c0,4.465-3.62,8.084-8.083,8.084c-4.465,0-8.084-3.62-8.084-8.084 c0-11.791,9.592-21.382,21.382-21.382c11.791,0,21.382,9.592,21.382,21.382C109.404,381.363,105.784,384.981,101.32,384.981z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E8CF52"
    },
    d: "M73.654,420.429c-4.465,0-8.084-3.62-8.084-8.084c0-2.875-2.338-5.214-5.214-5.214 c-2.875,0-5.214,2.339-5.214,5.214c0,4.465-3.621,8.083-8.084,8.083h-0.001c-4.464-0.001-8.084-3.62-8.083-8.084 c0.001-11.791,9.593-21.382,21.383-21.382c11.791,0,21.382,9.592,21.382,21.382C81.738,416.809,78.119,420.429,73.654,420.429z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9D7049"
    },
    d: "M469.963,370.974c0,37.505-30.403,67.908-67.908,67.908H173.541 c-37.505,0-67.907-30.403-67.907-67.908v-4.311c0-37.505,30.403-67.908,67.907-67.908h228.514c37.505,0,67.908,30.403,67.908,67.908 L469.963,370.974L469.963,370.974z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C16A73"
    },
    d: "M173.541,411.934c-22.585,0-40.96-18.375-40.96-40.96v-4.311c0-22.585,18.375-40.96,40.96-40.96 h228.514c22.585,0,40.96,18.375,40.96,40.96v4.311c0,22.585-18.375,40.96-40.96,40.96H173.541z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M402.055,389.39H173.541c-19.457,0-35.777-13.642-39.928-31.86 c-0.674,2.937-1.031,5.994-1.031,9.133v4.311c0,22.585,18.375,40.96,40.96,40.96h228.514c22.585,0,40.96-18.375,40.96-40.96v-4.311 c0-3.14-0.358-6.196-1.031-9.133C437.833,375.747,421.512,389.39,402.055,389.39z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D8A0"
    },
    d: "M324.985,171.99h-26.948c-4.465,0-8.084-3.62-8.084-8.084s3.62-8.084,8.084-8.084h26.948 c14.248,0,25.84-11.592,25.84-25.84s-11.592-25.84-25.84-25.84h-23.406c-4.465,0-8.084-3.62-8.084-8.084 c0-4.464,3.62-8.084,8.084-8.084h23.406c23.164,0,42.009,18.845,42.009,42.009C366.994,153.144,348.15,171.99,324.985,171.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCE9C3"
    },
    d: "M195.315,218.872c-4.465,0-8.084-3.62-8.084-8.084V192.33c0-20.132,16.378-36.51,36.51-36.51h44.294 c4.465,0,8.084,3.62,8.084,8.084s-3.62,8.084-8.084,8.084h-44.294c-11.216,0-20.341,9.125-20.341,20.341v18.457 C203.4,215.252,199.78,218.872,195.315,218.872z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F2D8A0"
    },
    d: "M263.573,129.952h-52.907c-24.037,0-43.593-19.556-43.593-43.594 c0-24.037,19.556-43.593,43.593-43.593h18.995c4.465,0,8.084,3.62,8.084,8.084s-3.62,8.084-8.084,8.084h-18.995 c-15.122,0-27.424,12.303-27.424,27.425s12.303,27.425,27.424,27.425h52.907c4.465,0,8.084,3.62,8.084,8.084 C271.658,126.332,268.038,129.952,263.573,129.952z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B0CE6F"
    },
    cx: 88.294,
    cy: 424.438,
    r: 21.65
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB4D4D"
    },
    d: "M402.055,325.702h-21.134l-23.387,23.387c-3.157,3.157-3.157,8.276,0,11.432 c1.579,1.579,3.648,2.368,5.717,2.368s4.138-0.789,5.717-2.368l34.776-34.776C403.182,325.723,402.621,325.702,402.055,325.702z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB4D4D"
    },
    d: "M332.415,325.702l-23.387,23.387c-3.158,3.157-3.158,8.276,0,11.432 c1.578,1.579,3.648,2.368,5.717,2.368s4.138-0.789,5.717-2.368l34.819-34.819H332.415z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB4D4D"
    },
    d: "M283.91,325.702l-23.387,23.387c-3.157,3.157-3.157,8.276,0,11.432 c1.579,1.579,3.648,2.368,5.717,2.368s4.139-0.789,5.717-2.368l34.819-34.819H283.91z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB4D4D"
    },
    d: "M235.405,325.702l-23.387,23.387c-3.157,3.157-3.157,8.276,0,11.432 c1.579,1.579,3.648,2.368,5.717,2.368s4.138-0.789,5.717-2.368l34.819-34.819H235.405z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#AB4D4D"
    },
    d: "M209.764,325.702H186.9l-23.387,23.387c-3.158,3.157-3.158,8.276,0,11.432 c1.579,1.579,3.648,2.368,5.717,2.368s4.138-0.789,5.717-2.368L209.764,325.702z"
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B0CE6F"
    },
    cx: 158.824,
    cy: 420.927,
    r: 25.161
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC60"
    },
    d: "M339.108,279.425c0.014-0.493,0.039-0.984,0.039-1.481c0-31.098-25.21-56.309-56.309-56.309 s-56.309,25.211-56.309,56.309c0,0.496,0.024,0.987,0.038,1.481H339.108z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M299.729,224.216c-5.332-1.674-11.006-2.581-16.891-2.581 c-31.098,0-56.309,25.211-56.309,56.309c0,0.496,0.024,0.987,0.038,1.481h33.783c-0.014-0.493-0.038-0.984-0.038-1.481 C260.311,252.732,276.884,231.392,299.729,224.216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7EEDF"
    },
    d: "M399.899,282.455c0,9.002-7.298,16.3-16.3,16.3H182.076c-9.003,0-16.299-7.298-16.299-16.3l0,0 c0-9.002,7.297-16.3,16.299-16.3h201.523C392.601,266.155,399.899,273.453,399.899,282.455L399.899,282.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M199.73,282.455c0-9.002,7.298-16.3,16.299-16.3h-33.954 c-9.003,0-16.299,7.298-16.299,16.3c0,9.002,7.297,16.3,16.299,16.3h33.954C207.028,298.755,199.73,291.458,199.73,282.455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F48911"
    },
    d: "M485.29,406.79c0,5.953-4.825,10.779-10.778,10.779h-51.739c-5.953,0-10.778-4.826-10.778-10.779 v-6.467c0-5.954,4.825-10.778,10.778-10.778h51.739c5.953,0,10.778,4.825,10.778,10.778V406.79z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EA9847"
    },
    d: "M437.862,428.194c0,5.953-4.826,10.778-10.779,10.778h-51.739c-5.954,0-10.779-4.826-10.779-10.778 v-6.467c0-5.954,4.825-10.779,10.779-10.779h51.739c5.953,0,10.779,4.825,10.779,10.779V428.194z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB7712"
    },
    d: "M491.757,428.194c0,5.953-4.825,10.778-10.779,10.778h-51.739c-5.953,0-10.778-4.826-10.778-10.778 v-6.467c0-5.954,4.825-10.779,10.778-10.779h51.739c5.953,0,10.779,4.825,10.779,10.779V428.194z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#53B559"
    },
    cx: 121.24,
    cy: 420.927,
    r: 25.161
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFDFBB"
    },
    d: "M512,458.456c0,5.954-4.826,10.779-10.779,10.779H10.779C4.826,469.235,0,464.41,0,458.456v-10.778 c0-5.953,4.826-10.779,10.779-10.779h490.442c5.953,0,10.779,4.826,10.779,10.779L512,458.456L512,458.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    },
    d: "M43.655,458.456v-10.778c0-5.953,4.826-10.779,10.779-10.779H10.779 C4.826,436.898,0,441.724,0,447.677v10.778c0,5.954,4.826,10.779,10.779,10.779h43.655C48.48,469.235,43.655,464.41,43.655,458.456z "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNormal);
export default __webpack_public_path__ + "static/media/normal.be1724e9c9817897a36f7d318fd1832f.svg";
export { ForwardRef as ReactComponent };